import React, { useEffect, useState, useRef } from 'react';
function useInView(threshold = 0.1) {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setInView(true);
    }, {
      threshold
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);
  return {
    ref,
    inView
  };
}
const benefits = [{
  emoji: '🧘',
  title: 'El Método 5-15',
  description: 'Micro-clínicas de calma para bajar el cortisol en minutos. Funciona incluso si el bebé está llorando. Sin meditación de 30 minutos. Sin silencio perfecto.'
}, {
  emoji: '💔',
  title: 'Adiós a la Culpa Migrante',
  description: 'Cómo soltar las expectativas de tu familia en tu país y sobrevivir en tu realidad actual. Porque criar en USA no es criar en tu tierra.'
}, {
  emoji: '👑',
  title: 'El Protocolo de Soberanía',
  description: 'Pasos exactos para recuperar tu identidad — la mujer, no solo la mamá — sin descuidar a tu hijo. Porque tú también importas.'
}];
export function SolutionSection() {
  const {
    ref: headerRef,
    inView: headerIn
  } = useInView();
  const {
    ref: cardsRef,
    inView: cardsIn
  } = useInView();
  const {
    ref: closingRef,
    inView: closingIn
  } = useInView();
  return <section style={{
    backgroundColor: 'var(--color-cream)'
  }} className="py-20 px-6" data-id="element-53">
      <div className="max-w-3xl mx-auto" data-id="element-54">
        {/* Benefit Cards */}
        <div ref={cardsRef} className="space-y-5 mb-16" data-id="element-55">
          {benefits.map((benefit, i) => <div key={benefit.title} className={`transition-all duration-700 ${cardsIn ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} style={{
          transitionDelay: `${i * 120}ms`
        }} data-id="element-56">
              <div className="flex gap-5 p-6 sm:p-8 rounded-2xl" style={{
            backgroundColor: 'var(--color-white-warm)',
            borderLeft: '4px solid var(--color-terracotta)',
            boxShadow: '0 4px 24px rgba(44, 24, 16, 0.07)'
          }} data-id="element-57">
                <div className="text-3xl flex-shrink-0 mt-1" data-id="element-58">
                  {benefit.emoji}
                </div>
                <div data-id="element-59">
                  <h3 className="font-serif text-xl sm:text-2xl font-bold mb-2" style={{
                color: 'var(--color-text-dark)'
              }} data-id="element-60">
                    {benefit.title}
                  </h3>
                  <p className="font-sans text-sm sm:text-base leading-relaxed" style={{
                color: 'var(--color-text-mid)'
              }} data-id="element-61">
                    {benefit.description}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        {/* Closing statement */}
        <div ref={closingRef} className={`text-center transition-all duration-700 ${closingIn ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} data-id="element-62">
          <div className="inline-block px-8 py-4 rounded-2xl" style={{
          backgroundColor: 'rgba(196, 98, 45, 0.08)'
        }} data-id="element-63">
            <p className="font-serif text-2xl sm:text-3xl italic font-semibold" style={{
            color: 'var(--color-burgundy)'
          }} data-id="element-64">
              "No es egoísmo. Es supervivencia."
            </p>
          </div>
        </div>
      </div>
    </section>;
}